import { makeAutoObservable, runInAction } from 'mobx'
import {
  MktuClass,
  RegistryForSite,
  RegistrySearchItem,
} from '@/services/Api/generated'
import { Loader } from '@/store/Loader.store'
import {
  getRegistriesRequestData,
  getRegistry,
  searchRegistries,
} from '@/app/actions/registries/actions'
import { mktuClassListStore } from '@/store/MktuClassList.store'
import { toast } from 'react-toastify'

export class OnlineSearchStore {
  searchString: string = ''
  selectedMktuClassesNumbers: MktuClass['classNumber'][] = []
  registrySearchItems: RegistrySearchItem[] = []
  total: number = 0
  isActualParams: boolean = false

  mktuClassShowInfo: MktuClass | null = null

  registryInfo: RegistryForSite | null = null

  registryItemsLoader = new Loader()
  registryInfoLoafer = new Loader()

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  toggleSelectedMktuClassInfo(mktuClass: MktuClass) {
    if (mktuClass.classNumber == this.mktuClassShowInfo?.classNumber) {
      this.mktuClassShowInfo = null
    } else {
      this.mktuClassShowInfo = mktuClass
    }
  }
  toggleSelectedMktuClassNumber(mktuClass: MktuClass) {
    if (this.selectedMktuClassesNumbers.includes(mktuClass.classNumber)) {
      this.selectedMktuClassesNumbers = this.selectedMktuClassesNumbers.filter(
        (i) => i !== mktuClass.classNumber
      )
    } else {
      this.selectedMktuClassesNumbers = [
        ...this.selectedMktuClassesNumbers,
        mktuClass.classNumber,
      ]
    }
    this.isActualParams = false
  }

  deleteSelectedMktuClassNumber(classNum: number) {
    this.selectedMktuClassesNumbers = this.selectedMktuClassesNumbers.filter(
      (i) => i !== classNum
    )
    this.isActualParams = false
  }

  setMktuClassShowInfo(selectedClass: MktuClass | null) {
    this.mktuClassShowInfo = selectedClass
  }

  async loadRegistryItems(searchString: string, captcha: string | null) {
    if (this.isActualParams || searchString == this.searchString) {
      return
    }

    this.registryItemsLoader.startLoading()
    runInAction(() => {
      this.registrySearchItems = []
      this.total = 0
    })
    try {
      const requestData: getRegistriesRequestData = {
        name: searchString,
      }

      if (this.selectedMktuClassesNumbers.length > 0) {
        requestData.mktuClasses = this.selectedMktuClassesNumbers.join(',')
      }

      const response = await searchRegistries(requestData, captcha)
      if (response.status) {
        if ('pagination' in response) {
          const paginationData = response.pagination
          if (typeof paginationData !== 'undefined') {
            runInAction(() => {
              this.total = paginationData.total || 0
            })
          }
        }

        if ('data' in response) {
          runInAction(() => {
            this.searchString = searchString
            this.registrySearchItems = response.data
          })
        }
      }
    } catch {
      toast.error('Что то пошло не так! Попробуйте позже')
    } finally {
      this.registryItemsLoader.stopLoading()
    }
  }

  async loadRegistryInfo(registry: RegistrySearchItem) {
    if (
      this.registryInfo != null &&
      this.registryInfo.registrationNumber === registry.number
    ) {
      return
    }

    this.registryInfoLoafer.startLoading()
    runInAction(() => {
      this.registryInfo = null
    })
    try {
      const responseData = await getRegistry(
        'TM-' + registry.folderName + registry.number
      )
      if (responseData.status && 'data' in responseData) {
        const registryData = responseData.data
        runInAction(() => {
          this.registryInfo = registryData
        })
        //Загружаем слова МКТУ...
        await Promise.allSettled(
          registryData.mktuClasses.map(async (mktuClassShort) => {
            await mktuClassListStore.getWords(mktuClassShort.classNum)
          })
        )
      }
    } catch {
      toast.error('Что то пошло не так! Попробуйте позже')
    } finally {
      this.registryInfoLoafer.stopLoading()
    }
  }
}

export const onlineSearchStore = new OnlineSearchStore()
